import './main.css';
import '@servicetitan/anvil-fonts/dist/css/anvil-fonts.css';
import '@servicetitan/design-system/dist/system.min.css';

import initializeReactScan from '@lib/utils/reactscan'; // must be imported before React and React DOM

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app/App';

initializeReactScan();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
